import React from 'react';
import './feature-tag.css';

export const FeatureTag = ({ 
  name, 
  color = '#6366f1', 
  size = 'medium',
  onClick,
  removable = false,
  onRemove,
  className = ''
}) => {
  const handleClick = (e) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <div 
      className={`feature-tag feature-tag--${size} ${className}`}
      style={{ 
        backgroundColor: color + '15', // 15% opacity
        borderColor: color,
        color: color
      }}
      onClick={handleClick}
    >
      <span className="feature-tag__text">{name}</span>
      {removable && (
        <button 
          className="feature-tag__remove"
          onClick={handleRemove}
          aria-label={`Remove ${name} tag`}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default FeatureTag;
